<ng-container *ngIf="{ request: requestHeatPumpDailyTelemetry$ | async } as resolver">
  <ng-container *ngIf="selectHeatpumpDailyTelemetryData$ | async; else skeletonTemplate">
    <lib-block-title
      id="heatpump-title"
      [title]="labels.title">
    </lib-block-title>
    <calendar-picker
      id="hp-picker"
      startView="month"
      (dateSelected)="dateSelection$.next($event)">
    </calendar-picker>

    <section
      id="hp-attributes-selector"
      class="fx-row fx-wrap fx-gap-3 fx-align-center">
      <mat-form-field
        subscriptSizing="dynamic"
        class="custom-mat-form-field fx-g-1 fx-b-0 min-w-75 custom-border-bottom">
        <mat-select
          multiple
          [value]="selectedAttributes$ | async"
          [compareWith]="compareFn"
          (selectionChange)="onAttributesValueChange($event.value)">
          <ng-container *ngFor="let byCategory of attributes; let first = first">
            <div
              class="tw-text-base text-font-medium p-3 bg-grey-100 text-grey-400"
              [ngClass]="{
                'mb-3': first,
                'my-3': !first,
              }">
              {{ labels[byCategory.categoryId] }}
            </div>
            <div class="mat-option-list px-3">
              <ng-container *ngFor="let attr of byCategory.attributes">
                <mat-option
                  class="tw-tabular-nums tw-font-normal tw-text-base text-grey-400"
                  [value]="attr"
                  [disabled]="(canDeselectAttributes$ | async) === false && (selectedAttributes$ | async)?.includes(attr)">
                  {{ labels[attr.id] }}
                </mat-option>
              </ng-container>
            </div>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </section>

    <ng-container *ngIf="hasData$ | async; else noDataTpl">
      <div
        *ngIf="(heatPumpChartOption$ | async) as option"
        echarts
        id="hp-chart"
        class="w-full block-bg-contrast"
        [autoResize]="true"
        [options]="option">
      </div>
    </ng-container>
    <ng-template #noDataTpl>
      <div
        id="hp-chart"
        class="min-h-100 no-data-message fx-col fx-center fx-gap-3">
        <mat-icon
          class="s-20"
          svgIcon="no_data">
        </mat-icon>
        <span class="text-grey-400 tw-font-normal tw-text-base">
          {{ labels.noDataForTheSelectedPeriod }}
          </span>
      </div>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #skeletonTemplate>
  <ion-skeleton-text
    id="heatpump-title"
    class="w-42 h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="hp-picker"
    class="w-90 h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="hp-attributes-selector"
    class="w-full h-20"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="hp-chart"
    class="w-full h-400"
    [animated]="true">
  </ion-skeleton-text>
</ng-template>
